import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), 'RemoveOutlined');